exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "strong{\n  font-family: 'Cormorant SC';\n  font-weight: bold;\n  font-size: 20px;\n}\n\nstrong:hover{\n\tcolor: #722f37;\n\tcursor: pointer;\n}\n\nul{\n  list-style-type: none;\n}\nli{\n  font-size: 20px;\n\n\n}\nli:hover{\n\tcursor: pointer;\n\tcolor: #722f37;\n}\n\ndiv{\n    margin-top: 20px;\n    max-width: inherit;\n    border: 40px solid lightgrey;\n    margin: 10px;\n    border-radius: 25px;\n    padding: 20px;\n    background: #ffb6c1;\n    height: inherit;\n }\nh3{\n\tcursor: default;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/user-profile/user-profile.component.css
// module id = ./src/app/user-profile/user-profile.component.css
// module chunks = 1